import CryptoJS from 'crypto-js'
import { CryptoKey } from './Const';
// import AES from 'crypto-js/aes';

const secure = async (data, type, format, callBack) => 
{
    if(type == "encrypt")
    {
        if(format == "text")
        {
            let cipherText = CryptoJS.AES.encrypt(String(data), CryptoKey.secret_key).toString();
            await callBack(cipherText)
        }
        else // Json
        {
            let cipherJson = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoKey.secret_key).toString();
            await callBack(cipherJson)
        }
    }
    else // Decrypt
    {
        if(format == 'text')
        {
            let decipherText = CryptoJS.AES.decrypt(data, CryptoKey.secret_key);
            let originalText = decipherText.toString(CryptoJS.enc.Utf8)
            await callBack(originalText)
        }
        else // Json
        {
            let decipherJson = CryptoJS.AES.decrypt(data, CryptoKey.secret_key)
            let originalJson = JSON.parse(decipherJson.toString(CryptoJS.enc.Utf8))
            await callBack(originalJson)
        }
    }
}

export default secure;